<mat-table [dataSource]="datasource">
  <ng-container matColumnDef="listingTitle">
    <mat-header-cell *matHeaderCellDef>Title</mat-header-cell>
    <mat-cell *matCellDef="let row">{{ row.listingTitle }}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="startDate">
    <mat-header-cell *matHeaderCellDef>Start Date</mat-header-cell>
    <mat-cell *matCellDef="let row">{{ row.startDate }}</mat-cell>
  </ng-container>
  @if (title === 'Not Sold Ballot') {
    <ng-container
      matColumnDef="stockQuantity"
      >
      <mat-header-cell *matHeaderCellDef>Stock Quantity</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.stockQuantity }}</mat-cell>
    </ng-container>
  }
  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef class="actions">Actions</mat-header-cell>
    <mat-cell *matCellDef="let row" class="actions">
      <a
        mat-icon-button
        [href]="row.listingUrl"
        target="_blank"
        matTooltip="View product."
        ><mat-icon>visibility</mat-icon></a
        >
        <!--  <button (click)="guestList(row)" mat-icon-button matTooltip="Guest list.">
        <mat-icon>list</mat-icon>
      </button> -->
    </mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>
